import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { EditionTypeCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EditionTypeCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name_esSelectedValue?: { displayId: string; id: string } | null;
  onName_esChange?: (value: string) => void;
  name_es: string;
  name_esError?: string;
  name_enSelectedValue?: { displayId: string; id: string } | null;
  onName_enChange?: (value: string) => void;
  name_en: string;
  name_enError?: string;
  name_ptSelectedValue?: { displayId: string; id: string } | null;
  onName_ptChange?: (value: string) => void;
  name_pt: string;
  name_ptError?: string;
  editionTypeCreateStore: EditionTypeCreateStore;
};

export const EditionTypeCreateForm: React.FC<EditionTypeCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name_es = "",
      name_esError,
      onName_esChange = () => {},
      name_en = "",
      name_enError,
      onName_enChange = () => {},
      name_pt = "",
      name_ptError,
      onName_ptChange = () => {},
      editionTypeCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="EditionType"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name_es":
                    onName_esChange?.(valor);
                    break;
                  case "name_en":
                    onName_enChange?.(valor);
                    break;
                  case "name_pt":
                    onName_ptChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={editionTypeCreateStore.getCardErrors("null")}
              title={langStore.groupEditionTypeLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name_es}
                  error={Boolean(name_esError)}
                  warning={
                    !name_esError &&
                    Boolean(editionTypeCreateStore.warnings["name_es"])
                  }
                  helperText={
                    name_esError ||
                    editionTypeCreateStore.warnings["name_es"]?.message
                  }
                  label={langStore.EditionTypeNameLabel + " (es)"}
                  onChange={(value: string) => onName_esChange(value)}
                  description={langStore.EditionTypeNameDescription}
                />

                <InputString
                  value={name_en}
                  error={Boolean(name_enError)}
                  warning={
                    !name_enError &&
                    Boolean(editionTypeCreateStore.warnings["name_en"])
                  }
                  helperText={
                    name_enError ||
                    editionTypeCreateStore.warnings["name_en"]?.message
                  }
                  label={langStore.EditionTypeNameLabel + " (en)"}
                  onChange={(value: string) => onName_enChange(value)}
                  description={langStore.EditionTypeNameDescription}
                />

                <InputString
                  value={name_pt}
                  error={Boolean(name_ptError)}
                  warning={
                    !name_ptError &&
                    Boolean(editionTypeCreateStore.warnings["name_pt"])
                  }
                  helperText={
                    name_ptError ||
                    editionTypeCreateStore.warnings["name_pt"]?.message
                  }
                  label={langStore.EditionTypeNameLabel + " (pt)"}
                  onChange={(value: string) => onName_ptChange(value)}
                  description={langStore.EditionTypeNameDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
